export const fieldNames = {
    status: 'Status',
    description: 'Description',
    report_name: 'Report name',
    report_status: 'Report status',
    report_definition: 'Report definition',
    schedule_name: 'Schedule name',
    schedule_status: 'Schedule status',
    schedule_definition: 'Schedule definition',
    attribute_name: 'Attribute name',
    attribute_status: 'Attribute status',
    attribute_definition: 'Attribute definition',
    name: 'Name',
    definition: 'Definition'
}

export const statusOptions = [
    {
        text:'New',
        value: 'new'
    },
    {
        text:'Approved',
        value: 'approved'
    },
    {
        text:'Proposed',
        value: 'proposed'
    },
    {
        text:'Inactive',
        value: 'inactive'
    }
]